import { useRef, useState } from "react";
import { useLocation, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { OrbitingUniverse } from "@/components/OrbitingUniverse";
import { ChatInterface } from "@/components/ChatInterface";
import { AlphardPromoPopup } from "@/components/AlphardPromoPopup";

export const Concierge = () => {
  const location = useLocation();
  const initialMessage = location.state && location.state.initialMessage;
  const [sessionId, setSessionId] = useState(null);
  const chatRef = useRef(null);

  const talkTo = (prompt) => chatRef.current && chatRef.current.send(prompt);

  return (
    <div className="relative h-screen w-screen overflow-hidden sadara-bg grain" data-testid="concierge-room">
      <header className="absolute top-0 left-0 right-0 z-30 flex items-center justify-between px-5 md:px-8 py-4">
        <div>
          <h1 className="font-display text-xl md:text-2xl tracking-wide text-foreground leading-none" data-testid="brand-name">
            Sadara <span className="gold-text">Tour</span> Zanzibar
          </h1>
          <p className="text-[10px] md:text-[11px] uppercase tracking-[0.35em] text-gold/60 mt-1">Five-Star Private Concierge</p>
        </div>
        <Link to="/" className="hidden md:inline-flex items-center gap-2 text-xs text-gold/70 hover:text-gold transition-colors" data-testid="back-to-home">
          <ArrowLeft className="w-4 h-4" /> Home
        </Link>
      </header>

      <main className="relative z-10 h-full flex flex-col lg:flex-row">
        <section className="relative flex-1 hidden md:flex items-center justify-center pt-16" data-testid="universe-section">
          <OrbitingUniverse onSelect={talkTo} />
        </section>

        <aside className="w-full lg:w-[460px] h-full flex flex-col pt-20 md:pt-16 pb-3 px-3 md:px-4" data-testid="chat-section">
          <div className="glass rounded-3xl flex-1 flex flex-col overflow-hidden">
            <ChatInterface ref={chatRef} sessionId={sessionId} setSessionId={setSessionId} initialMessage={initialMessage} />
          </div>
        </aside>
      </main>

      <AlphardPromoPopup onRequestTransfer={talkTo} />
    </div>
  );
};
